<div class="editor">
    <quill-editor id="quillEditor" [(ngModel)]="model[fieldName]" [modules]="editorConfig" style="width: 100%;"></quill-editor>
</div>
